import gsap from 'gsap';
import React, { useCallback, useEffect, useRef } from 'react';
import styled from 'styled-components';
import { IconBase } from '../Base';
const Wrapper = styled.div `
  --document-edit-pen-x: 0px;
  --document-edit-pen-y: 0px;
  --document-edit-pen-rotate: 0deg;
  --document-edit-line-1-opacity: 1;
  --document-edit-line-1-y: 0px;
  --document-edit-line-2-offset: 3px;
  --document-edit-line-2-y: 0px;
  --document-edit-line-3-offset: 3px;
  --document-edit-line-3-y: 0px;
  --document-edit-line-4-offset: 6px;

  position: relative;
  display: table;
  svg {
    path {
      &:last-child {
        transform-origin: 54.15% 66.65%;
        transform: translate(var(--document-edit-pen-x), 0) rotate(var(--document-edit-pen-rotate)) translateZ(0);
      }
      &:nth-child(2),
      &:nth-child(3),
      &:nth-child(4),
      &:nth-child(5) {
        stroke-dasharray: 6px;
      }
      &:nth-child(2) {
        opacity: var(--document-edit-line-1-opacity);
        transform: translateY(var(--document-edit-line-1-y));
      }
      &:nth-child(3) {
        stroke-dashoffset: var(--document-edit-line-2-offset);
        transform: translateY(var(--document-edit-line-2-y));
      }
      &:nth-child(4) {
        stroke-dashoffset: var(--document-edit-line-3-offset);
        transform: translateY(var(--document-edit-line-3-y));
      }
      &:nth-child(5) {
        stroke-dashoffset: var(--document-edit-line-4-offset);
      }
    }
  }
`;
const Pencil = styled.path `
  fill: var(--icon-background, ${({ theme }) => theme.background});
`;
export const IconDocumentEdit = ({ onDone, running, ...props }) => {
    const wrapperRef = useRef(null);
    const triggerDone = useCallback(() => {
        if (onDone) {
            onDone();
        }
    }, [onDone]);
    useEffect(() => {
        if (running) {
            const wrapper = wrapperRef.current;
            if (!wrapper) {
                return;
            }
            gsap.to(wrapper, {
                keyframes: [
                    {
                        '--document-edit-line-1-y': '-3.33px',
                        '--document-edit-line-1-opacity': '0',
                        '--document-edit-line-2-y': '-3.33px',
                        '--document-edit-line-2-offset': '0px',
                        '--document-edit-line-3-y': '-3.33px',
                        duration: 0.2,
                    },
                    {
                        '--document-edit-pen-x': '-6px',
                        '--document-edit-pen-rotate': '-24deg',
                        duration: 0.2,
                    },
                    {
                        '--document-edit-pen-y': '0px',
                        '--document-edit-pen-x': '0px',
                        '--document-edit-pen-rotate': '12deg',
                        '--document-edit-line-4-offset': '3px',
                        duration: 0.25,
                    },
                    {
                        '--document-edit-pen-rotate': '0deg',
                        duration: 0.3,
                        clearProps: true,
                        onComplete: triggerDone,
                    },
                ],
            });
        }
    }, [running, onDone]);
    return (React.createElement(Wrapper, { className: props.className, ref: wrapperRef },
        React.createElement(IconBase, { ...props },
            React.createElement("g", { strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round", style: { stroke: 'var(--icon-color)' } },
                React.createElement("path", { d: "M15 15.8333C15 16.2754 14.8244 16.6993 14.5118 17.0118C14.1993 17.3244 13.7754 17.5 13.3333 17.5H4.16667C3.72464 17.5 3.30072 17.3244 2.98816 17.0118C2.67559 16.6993 2.5 16.2754 2.5 15.8333V4.16667C2.5 3.72464 2.67559 3.30072 2.98816 2.98816C3.30072 2.67559 3.72464 2.5 4.16667 2.5H13.3333C13.7754 2.5 14.1993 2.67559 14.5118 2.98816C14.8244 3.30072 15 3.72464 15 4.16667V15.8333Z" }),
                React.createElement("path", { d: "M5.83331 6.66666H11.67" }),
                React.createElement("path", { d: "M5.83331 10H11.67" }),
                React.createElement("path", { d: "M5.83331 13.3333H11.67" }),
                React.createElement("path", { d: "M5.83331 13.3333H11.67" }),
                React.createElement(Pencil, { d: "M10.8333 11.1783V13.3333H12.9883C13.2093 13.3333 13.4212 13.2455 13.5775 13.0892L16.9825 9.68417C17.3139 9.35257 17.5 8.90296 17.5 8.43417C17.5 7.96537 17.3139 7.51576 16.9825 7.18417C16.6509 6.85278 16.2013 6.66663 15.7325 6.66663C15.2637 6.66663 14.8141 6.85278 14.4825 7.18417L11.0775 10.5892C10.9212 10.7454 10.8334 10.9573 10.8333 11.1783V11.1783Z" })))));
};
//# sourceMappingURL=DocumentEdit.js.map